import { SIGN_METHOD_MANUAL } from './constants';

const hasSignMethodMarkedAsSigned = (participant) => (
  participant.signMethod === SIGN_METHOD_MANUAL
);

export default hasSignMethodMarkedAsSigned;
